import { DatePicker as AntdDatePicker } from 'antd';
import {WeaDatePicker} from 'ecCom';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.less';
export default class DatePicker extends React.Component<any, any>{
    div: HTMLDivElement;
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }
    openModal = () => {
        this.toggleOpen({ open: true });
    }
    fixedPosition = (left, top) => {
        this.setState({
            left, top
        })
    }
    toggleOpen = (state) => {
        this.setState(state, () => {
            if (!state.open) {
                if (this.props.onClose) {
                    this.props.onClose((ReactDOM.findDOMNode(this)).parentElement);
                }
            }
        });
    }
    componentDidMount() {
        this.div = document.createElement('div');
        this.div.className = 'edc-date-picker-mask';
        this.div.style.display = 'none';
        document.body.appendChild(this.div);
    }
    componentDidUpdate() {
        if (this.div) {
            if (this.state.open) {
                this.div.style.display = 'block';
            } else {
                this.div.style.display = 'none';
            }
        }
    }
    componentWillUnmount() {
        document.body.removeChild(this.div);
    }
    render() {
        const {type} = this.props;
        if(type == 'yearMonth'){
            return (
                <div style={{ display: '' }}>
                    <div style={{ position: 'fixed', top: this.state.top, left: this.state.left, visibility: 'hidden' }}>
                        <WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@a0b7a0`}
                            format={this.props.formatter}
                            showTime={this.props.showtime}
                            open={this.state.open}
                            toggleOpen={this.toggleOpen}
                            onChange={this.changeValue}
                            popupStyle={{ left: this.state.left, top: this.state.top }}
                            value={this.props.value}
                        />
                    </div>
                </div>
            )
        }else{
            return (
                <div style={{ display: '' }}>
                    <div style={{ position: 'fixed', top: this.state.top, left: this.state.left, visibility: 'hidden' }}>
                        <AntdDatePicker ecId={`${this && this.props && this.props.ecId || ''}_AntdDatePicker@phq4ul`}
                            format={this.props.formatter}
                            showTime={this.props.showtime}
                            open={this.state.open}
                            toggleOpen={this.toggleOpen}
                            onChange={this.changeValue}
                            popupStyle={{ left: this.state.left, top: this.state.top }}
                            value={this.props.value}
                        />
                    </div>
                </div>
            )
        }
        
    }
    changeValue = (moment, date2) => {
        const {type} = this.props;
        if (typeof this.props.onChange === 'function') {
            if(type == 'yearMonth'){
                this.props.onChange(moment);
            }else{
                this.props.onChange(date2);
            }
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/list/excel/coms/date-picker/index.tsx